<template>

    <div class="fuid-form__select">

        <b-form-select v-model="value" :id="id" :options="options" @change="groupChange"></b-form-select>

        <div v-if="error" class="fuid-form__select_error merror">{{ $t('forms.groupfull') }}</div>

    </div>

</template>

<script>

    import { mapActions } from 'vuex'

    export default {

        props:['id','options','error'],

        data() {

            return {

                value: null,
                prevValue: null

            }

        },

        methods: {

            ...mapActions('Prematriculas', ['resetSelectsErrors']),
            ...mapActions('Matricula', ['removeGroupFromAlumno']),

            groupChange(value) {

                if(value !== null) {

                    this.$emit('changeSelect',value)
                    this.prevValue = value

                } else {

                    this.removeGroupFromAlumno( { alumnoId: this.prevValue.alumno, groupId: this.prevValue.group_id } )

                }

                if(this.error) {

                    this.resetSelectsErrors( { id: this.id } )

                }

            }

        },

        watch: {

            value: function(value) {

                if(value == null) {

                    this.$emit('emptySelect',this.id)

                }

            }

        }

    }

</script>